
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as aboutcmOlMtgh0xy7aWxAyOhlQufva4uyAY4tLm1ILX3BBaUMeta } from "/opt/build/repo/pages/about.vue?macro=true";
import { default as indexZbOOHPGnEANCsuwhGoiZGQW4ezjCddrf3do_453TgRIBUMeta } from "/opt/build/repo/pages/chats/index.vue?macro=true";
import { default as _91groupId_93XdmVYu_VdwRBMJPSi59dDvUuus1QXjBZ4l4gHh5qmggMeta } from "/opt/build/repo/pages/chats/[groupId].vue?macro=true";
import { default as chatslgUY1tjhvv92_456sk13VI9b2Rq2TGIrCwLCt2sFn5p_QMeta } from "/opt/build/repo/pages/chats.vue?macro=true";
import { default as indexaAs6F0uOO1PbNxqH8DD_45e04gSZQCarVD9TCXJYV94KEMeta } from "/opt/build/repo/pages/index.vue?macro=true";
import { default as logindGU_Y4tTcWsCg9HnKfbgxniTJNnqn8Xqf4N3mbSf_459QMeta } from "/opt/build/repo/pages/login.vue?macro=true";
import { default as sign_45upsbyFTKzb27ZDAAG4Ck628G_45pZQrSR_Bg9SgR2KtFDGcMeta } from "/opt/build/repo/pages/sign-up.vue?macro=true";
import { default as _91id_93H29NpFNKE3DaYpfvlDvVa_45qZvuH5QgsV4obvixbF3NQMeta } from "/opt/build/repo/pages/customers/[id].vue?macro=true";
import { default as index1SPkbjywRoud9w2sBIotfuYOboRLHDRntUZqLHeIHMMMeta } from "/opt/build/repo/pages/customers/index.vue?macro=true";
import { default as customersxaK_6S7keHAOv_7RHa1IVPI_uKioLS6lthXcLxidnYoMeta } from "/opt/build/repo/pages/customers.vue?macro=true";
import { default as cardsHUCl_45lSYsKkRdy8SKBhhNdGWkv2LxPi1TMZF5faTfocMeta } from "/opt/build/repo/pages/playground/cards.vue?macro=true";
import { default as formshuvnDXBOctV_45lbYd2ZNHK9oppF7RuMY3hmSiZhY6kUMMeta } from "/opt/build/repo/pages/playground/forms.vue?macro=true";
import { default as index3DJjduPfCWMJwLCChNsljZPXC31_45meah_2sv3urOwWQMeta } from "/opt/build/repo/pages/playground/index.vue?macro=true";
import { default as modalWWpjadrEXXYN_4K8RVCDZ0CdpD60pHyhkqxbX5S1_G0Meta } from "/opt/build/repo/pages/playground/modal.vue?macro=true";
import { default as uikitm8GfAaMFfAm_45Ru95w4nJcFQEaPB0DzEfC_45SO35G_45XAoMeta } from "/opt/build/repo/pages/playground/uikit.vue?macro=true";
import { default as videoPB3yogc0zIDVW_lo2JGLO82xtD_45dYIBxt7PtcuKTdhAMeta } from "/opt/build/repo/pages/playground/video.vue?macro=true";
import { default as dialog6wXA71KDxolBhQtKZ1aaD6ZU7r5YA1Gm7kJIsv4j4J4Meta } from "/opt/build/repo/pages/playground/dialog.vue?macro=true";
import { default as sentryCsgJrRwWvnqTEwBNNaM2xfZttyPIR0sfbSluOpWqJ0gMeta } from "/opt/build/repo/pages/playground/sentry.vue?macro=true";
import { default as tablesakvvotcq4rBSJLdXiFeaSMd78jcT3gE_45d2_456A9nQ84IMeta } from "/opt/build/repo/pages/playground/tables.vue?macro=true";
import { default as playgroundGNh_45cDxzwpmVbJdD2D62z8_45TudZVngBVAbbHOa0s5YcMeta } from "/opt/build/repo/pages/playground.vue?macro=true";
import { default as reset_45password2S4NlOq3P1ZR9XrtNBf0_GEwuTrW3VEUJcKJFtfVRKcMeta } from "/opt/build/repo/pages/reset-password.vue?macro=true";
import { default as forgot_45passwordOIFCeCN4AMh8hgrToHpDpWjsGVd3MBWi_zvta3PbADwMeta } from "/opt/build/repo/pages/forgot-password.vue?macro=true";
import { default as account_45validationqFgjOnXKnzvlcsCeY9k_cYgdW7Coo8ynEjG74_rynZEMeta } from "/opt/build/repo/pages/account-validation.vue?macro=true";
export default [
  {
    name: "about",
    path: "/about",
    meta: aboutcmOlMtgh0xy7aWxAyOhlQufva4uyAY4tLm1ILX3BBaUMeta || {},
    component: () => import("/opt/build/repo/pages/about.vue")
  },
  {
    name: chatslgUY1tjhvv92_456sk13VI9b2Rq2TGIrCwLCt2sFn5p_QMeta?.name,
    path: "/chats",
    component: () => import("/opt/build/repo/pages/chats.vue"),
    children: [
  {
    name: "chats",
    path: "",
    component: () => import("/opt/build/repo/pages/chats/index.vue")
  },
  {
    name: "chats-groupId",
    path: ":groupId()",
    component: () => import("/opt/build/repo/pages/chats/[groupId].vue")
  }
]
  },
  {
    name: "index",
    path: "/",
    meta: indexaAs6F0uOO1PbNxqH8DD_45e04gSZQCarVD9TCXJYV94KEMeta || {},
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: logindGU_Y4tTcWsCg9HnKfbgxniTJNnqn8Xqf4N3mbSf_459QMeta || {},
    component: () => import("/opt/build/repo/pages/login.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: sign_45upsbyFTKzb27ZDAAG4Ck628G_45pZQrSR_Bg9SgR2KtFDGcMeta || {},
    component: () => import("/opt/build/repo/pages/sign-up.vue")
  },
  {
    name: customersxaK_6S7keHAOv_7RHa1IVPI_uKioLS6lthXcLxidnYoMeta?.name,
    path: "/customers",
    component: () => import("/opt/build/repo/pages/customers.vue"),
    children: [
  {
    name: "customers-id",
    path: ":id()",
    component: () => import("/opt/build/repo/pages/customers/[id].vue")
  },
  {
    name: "customers",
    path: "",
    meta: index1SPkbjywRoud9w2sBIotfuYOboRLHDRntUZqLHeIHMMMeta || {},
    component: () => import("/opt/build/repo/pages/customers/index.vue")
  }
]
  },
  {
    name: playgroundGNh_45cDxzwpmVbJdD2D62z8_45TudZVngBVAbbHOa0s5YcMeta?.name,
    path: "/playground",
    component: () => import("/opt/build/repo/pages/playground.vue"),
    children: [
  {
    name: "playground-cards",
    path: "cards",
    meta: cardsHUCl_45lSYsKkRdy8SKBhhNdGWkv2LxPi1TMZF5faTfocMeta || {},
    component: () => import("/opt/build/repo/pages/playground/cards.vue")
  },
  {
    name: "playground-forms",
    path: "forms",
    meta: formshuvnDXBOctV_45lbYd2ZNHK9oppF7RuMY3hmSiZhY6kUMMeta || {},
    component: () => import("/opt/build/repo/pages/playground/forms.vue")
  },
  {
    name: "playground",
    path: "",
    meta: index3DJjduPfCWMJwLCChNsljZPXC31_45meah_2sv3urOwWQMeta || {},
    component: () => import("/opt/build/repo/pages/playground/index.vue")
  },
  {
    name: "playground-modal",
    path: "modal",
    meta: modalWWpjadrEXXYN_4K8RVCDZ0CdpD60pHyhkqxbX5S1_G0Meta || {},
    component: () => import("/opt/build/repo/pages/playground/modal.vue")
  },
  {
    name: "playground-uikit",
    path: "uikit",
    meta: uikitm8GfAaMFfAm_45Ru95w4nJcFQEaPB0DzEfC_45SO35G_45XAoMeta || {},
    component: () => import("/opt/build/repo/pages/playground/uikit.vue")
  },
  {
    name: "playground-video",
    path: "video",
    meta: videoPB3yogc0zIDVW_lo2JGLO82xtD_45dYIBxt7PtcuKTdhAMeta || {},
    component: () => import("/opt/build/repo/pages/playground/video.vue")
  },
  {
    name: "playground-dialog",
    path: "dialog",
    meta: dialog6wXA71KDxolBhQtKZ1aaD6ZU7r5YA1Gm7kJIsv4j4J4Meta || {},
    component: () => import("/opt/build/repo/pages/playground/dialog.vue")
  },
  {
    name: "playground-sentry",
    path: "sentry",
    meta: sentryCsgJrRwWvnqTEwBNNaM2xfZttyPIR0sfbSluOpWqJ0gMeta || {},
    component: () => import("/opt/build/repo/pages/playground/sentry.vue")
  },
  {
    name: "playground-tables",
    path: "tables",
    meta: tablesakvvotcq4rBSJLdXiFeaSMd78jcT3gE_45d2_456A9nQ84IMeta || {},
    component: () => import("/opt/build/repo/pages/playground/tables.vue")
  }
]
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: reset_45password2S4NlOq3P1ZR9XrtNBf0_GEwuTrW3VEUJcKJFtfVRKcMeta || {},
    component: () => import("/opt/build/repo/pages/reset-password.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgot_45passwordOIFCeCN4AMh8hgrToHpDpWjsGVd3MBWi_zvta3PbADwMeta || {},
    component: () => import("/opt/build/repo/pages/forgot-password.vue")
  },
  {
    name: "account-validation",
    path: "/account-validation",
    meta: account_45validationqFgjOnXKnzvlcsCeY9k_cYgdW7Coo8ynEjG74_rynZEMeta || {},
    component: () => import("/opt/build/repo/pages/account-validation.vue")
  }
]